/** Die gespeicherte Seitenleiste lesen und aendern (N-01). */
import { useCallback } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { seitenleisteLaden, seitenleisteSpeichern } from '@/db/repositories/oberflaeche';
import { einstellungAus, LEERE_EINSTELLUNG, type SeitenleistenEinstellung } from '@/domain/oberflaeche/seitenleiste';

export function useSeitenleiste() {
  const roh = useLiveQuery(() => db.oberflaeche.get('seitenleiste'), [], undefined);
  const einstellung = einstellungAus(roh) ?? LEERE_EINSTELLUNG;
  // Immer vom gespeicherten Stand aus aendern - nicht vom (evtl. veralteten) Render.
  const aendern = useCallback(async (f: (e: SeitenleistenEinstellung) => SeitenleistenEinstellung) => {
    await seitenleisteSpeichern(f(await seitenleisteLaden()));
  }, []);
  return { einstellung, aendern };
}
